import { ApiService } from "../../constants/ApiService";
import { HttpService } from "../../constants/HTTPService";

export const getListRequestType = async () => {
  const dataAPI = await HttpService.get(
    ApiService.alesaForm.getListRequestType
  );

  return dataAPI.data.data;
};

export const getListRequestStatus = async (roleId: string) => {
  const dataAPI = await HttpService.post(
    ApiService.alesaForm.getListRequestStatus,
    JSON.stringify({
      RoleId: roleId,
    })
  );

  return dataAPI.data.data;
};

export const getListOfRequest = async (
  requestTypeID?: string,
  requestStatusID?: string,
  startDateString?: string,
  endDateString?: string,
  roleId?: string,
  binusianID?: string,
  searchText?: string
) => {
  const dataAPI = await HttpService.post(
    ApiService.alesaDashboard.getListOfRequest,
    JSON.stringify({
      RequestTypeID: requestTypeID,
      RequestStatusID: requestStatusID,
      StartDateString: startDateString,
      EndDateString: endDateString,
      RoleId: roleId,
      BinusianID: binusianID,
      SearchText: searchText,
    })
  );

  return dataAPI.data.data;
};

export const deleteListOfRequest = async (
  listRequestID?: string[],
  userUp?: string
) => {
  const dataAPI = await HttpService.post(
    ApiService.alesaDashboard.deleteListOfRequest,
    JSON.stringify({
      ListRequestID: listRequestID,
      UserUp: userUp,
    })
  );

  return dataAPI.data.data;
};
